import { useMutation } from '@tanstack/react-query';
import { Button, CardContent, Stack, Typography } from '@mui/material';

import { useAuth } from '@barboxx/admin-utils';
import Api from '@barboxx/api';
import { Can } from '@barboxx/react-utils';

// Generated by Copilot

export function NoStripeData({
    refetch,
    businessId,
}: {
    refetch: () => void;
    businessId: number;
}) {
    const { auth } = useAuth();

    const isInternalUser = auth.user?.userType === 'Internal';
    const isBusinessOwner =
        auth.user?.userType === 'Business' &&
        auth.user?.roles?.includes('Owner');
    const isBusinessNonOwner =
        auth.user?.userType === 'Business' && !isBusinessOwner;

    const createStripeAccountMutation = useMutation({
        mutationKey: ['createAccount', businessId],
        mutationFn: () =>
            Api.Stripe.createAccount({
                businessId,
            }),
        onSuccess: () => {
            refetch();
        },
        onError: (error, variables, context) => {
            console.error('Error creating account:', error);
        },
    });

    const handleCreateAccount = () => {
        createStripeAccountMutation.mutate();
    };

    return (
        <CardContent>
            <Stack gap={2}>
                {isBusinessOwner && (
                    <>
                        <Typography variant="h6">Step 1 of 2:</Typography>

                        <Typography variant="body1">
                            Clicking &quot;Create Account&quot; is the 1st step
                            to processing payments and receiving your business
                            payouts directly to your bank account.
                        </Typography>

                        <Can I="create" a="BusinessStripeAccount">
                            <Button
                                loading={createStripeAccountMutation.isPending}
                                onClick={handleCreateAccount}
                                variant="contained"
                            >
                                Create account
                            </Button>
                        </Can>
                    </>
                )}

                {isBusinessNonOwner && (
                    <Typography variant="body1">
                        Only a business owner can create this Stripe account.
                        Please ask your owner to complete setup on this
                        financial page.
                    </Typography>
                )}

                {isInternalUser && (
                    <Typography variant="body1">
                        Internal users can&apos;t create Stripe business
                        accounts. Please have the business owner complete setup
                        in the business financial tab.
                    </Typography>
                )}

                {createStripeAccountMutation.error && (
                    <Typography variant="body1" color="error">
                        Something went wrong Creating account!
                    </Typography>
                )}
            </Stack>
        </CardContent>
    );
}
